
import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

import { DATA } from '@/config/data';

import { DepositModel } from '@/models/deposit';
import { ChangedHistoryModel } from '@/models/changed-history';
import { PaymentHistoryModel } from '@/models/payment-history';

import depositService from '@/services/deposit-services';

import CustomerInfo from './components/CustomerInfo.vue';
import ChangedHistory from './components/ChangedHistory.vue';
import PaymentHistory from './components/PaymentHistory.vue';
import BillOfLading from './components/BillOfLading.vue';
import DepositDetailFooter from './components/DepositDetailFooter.vue';
import AmountDetailDeposit from './components/AmountDetailDeposit.vue';
import ChatBox from '@/shared/components/ChatBox.vue';

@Component({
    components: {
        'customer-info': CustomerInfo,
        'chat-box': ChatBox,
        'change-hist': ChangedHistory,
        'payment-hist': PaymentHistory,
        'bill-of-lading' : BillOfLading,
        'deposit-detail-footer': DepositDetailFooter,
        'amount-detail-deposit': AmountDetailDeposit
    }
})
export default class DetailDeposit extends Vue {
    private deposit: DepositModel = new DepositModel();
    get depositId() {
        return this.$route.params.id;
    }

    @Watch('depositId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.depositId) {
            this.initComponent();
        }
    }

    private async initComponent() {
        this.deposit.changedHistories = [];
        this.deposit.paymentHistory = [];
        await this.loadData();
    }

    private getStatus(value: any) {
        return DATA.depositStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private onCancelOrder(data: any) {
        this.deposit = {
            ...this.deposit,
            status: 1,
            statusDetail: this.getStatus(1)
        }
    }

    private async loadData() {
        if (this.depositId) {
            const result = await depositService.getDepositByID(this.depositId);
            if (result && result.status === 200 && (result.data.data.length > 0 || result.data.data.ID > 0)) {
                const item = result.data.data;
                this.deposit = new DepositModel();
                this.deposit.createdBy = item.CreatedBy;
                this.deposit.createdDate = item.CreatedDate;
                this.deposit.curentCNYVN = item.CurentCNYVN;
                this.deposit.dathangID = item.DathangID;
                this.deposit.depositCode = item.DepositCode;
                this.deposit.feeShipCN = item.FeeShipCN;
                this.deposit.feeShipVND = item.FeeShipVND;
                this.deposit.weightPrice = item.WeightPrice;
                this.deposit.feeWeight = item.FeeWeight;
                this.deposit.feeWeightCK = item.FeeWeightCK;
                this.deposit.id = item.ID;
                this.deposit.isChangeWeightByAdmin = item.IsChangeWeightByAdmin;
                this.deposit.isFeeShip = item.IsFeeShip;
                this.deposit.isFragileGoods = item.IsFragileGoods;
                this.deposit.isCheck = item.IsCheck;
                this.deposit.chinaStoreID = item.ChinaStoreID;
                this.deposit.orderWeight = item.OrderWeight;
                this.deposit.orderWeightRound = item.OrderWeightRound;
                this.deposit.payment = item.Payment;
                this.deposit.guaranteeAmount = item.GuaranteeAmount;
                this.deposit.guaranteeAmountVND = item.GuaranteeAmountVND;
                this.deposit.surcharge = item.Surcharge;
                this.deposit.feeOther = item.FeeOther;
                this.deposit.feeOtherNote = item.FeeOtherNote;
                this.deposit.fragileFee = item.FragileFee;
                this.deposit.fragileFeeVND = item.FragileFeeVND;
                this.deposit.checkFeeType = item.CheckFeeType;
                this.deposit.checkFee = item.CheckFee;
                this.deposit.checkFeeVND = item.CheckFeeVND;
                this.deposit.receivePlaceID = item.ReceivePlaceID;
                this.deposit.salerID = item.SalerID;
                this.deposit.status = item.Status;
                this.deposit.statusDetail = DATA.depositStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                this.deposit.totalPriceVND = item.TotalPriceVND;
                this.deposit.discountVND = item.DiscountVND;
                this.deposit.uId = item.UID;
                this.deposit.updateDateWeightByAdmin = item.UpdateDateWeightByAdmin;
                this.deposit.userName = item.Username;
                this.deposit.feeShipType = item.FeeShipType;

                this.deposit.changedHistories = [];
                for(const hist of item.ChangedHistories) {
                    const histItem = new ChangedHistoryModel();
                    histItem.id = hist.ID;
                    histItem.orderId = hist.OrderID;
                    histItem.uId = hist.UID;
                    histItem.userName = hist.Username;
                    histItem.historyContent = hist.HistoryContent;
                    histItem.orderType = hist.OrderType;
                    histItem.type = hist.Type;
                    histItem.createDate = moment(hist.CreatedDate).format('DD-MM-YYYY HH:mm:ss');;
                    this.deposit.changedHistories.push(histItem);
                }

                this.deposit.paymentHistory = [];
                for(const pay of item.PaymentHistory) {
                    const payItem = new PaymentHistoryModel();
                    payItem.amount = pay.Amount;
                    payItem.createBy = pay.CreateBy;
                    payItem.createDate = moment(pay.CreatedDate).format('DD-MM-YYYY HH:mm:ss');
                    payItem.id = pay.ID;
                    payItem.modifiedBy = pay.ModifiedBy;
                    payItem.modifiedDate = pay.ModifiedDate;
                    payItem.orderId = pay.OrderID;
                    payItem.orderType = pay.OrderType;
                    payItem.status = pay.Status;
                    payItem.statusDetail = (DATA.paymentStatusList.find(x => x.value === pay.Status) || { name: 'Khác' }).name;
                    payItem.type = pay.Type;
                    payItem.typeName = (DATA.paymentTypeList.find(x => x.value === pay.Type) || { name: 'Khác' }).name;
                    this.deposit.paymentHistory.push(payItem);
                }

            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: `Không tìm thấy đơn ký gửi [${this.depositId}]`,
                });
            }
        }
    }
}
